"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplicationSteps = void 0;
var ApplicationSteps = exports.ApplicationSteps = {
  COMPLETED: 'completed',
  CURRENT: 'current',
  INCOMPLETE: 'incomplete'
};
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');